import asArray from 'utils/arrays/asArray.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';

const isNotDeleted = (s) => 'deleted' !== s.status;
const isNotWaitlist = (s) => !s.serves_as_waitlist && !s.servesAsWaitlist;
const hasColumn = (s) => s.has_column || s.hasColumn;

const filterActiveStylists = (stylists) =>
  asArray(stylists)
    .filter(alwaysSame)
    .filter((s) => isNotDeleted(s) && isNotWaitlist(s) && hasColumn(s));

export default filterActiveStylists;
